import { RouteObject } from 'react-router-dom';
import { CreateJob, FeatureCreateJob } from './feature-create-job';

export const EMPLOYER_ROUTES: RouteObject[] = [
   {
      path: '/user/createjob',
      Component: FeatureCreateJob,
   },
];
